// @flow
import React from 'react';
import type { Node } from 'react';
import { FormattedMessage } from 'react-intl';
import makeStyles from '@material-ui/core/styles/makeStyles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MuiSelect from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

const useStyles = makeStyles({
    root: {
        minWidth: 200
    }
});

type Props = $ReadOnly<{
    label: Node,
    path: $ReadOnlyArray<string>,
    value: string | number,
    items: $ReadOnlyArray<$ReadOnly<{
        label: Node,
        value: string | number
    }>>,

    onChange: (path: $ReadOnlyArray<string>, value: boolean) => void
}>;

function Select({ label, path, value, items, onChange }: Props) {
    const classes = useStyles();
    const handleChange = (e) => onChange(path, e.target.value);

    return (
        <FormControl variant="outlined" className={classes.root}>
            <InputLabel>
                {label}
            </InputLabel>
            <MuiSelect
                value={value || ''}
                onChange={handleChange}
            >
                <MenuItem value="">
                    <em>
                        <FormattedMessage
                            id="options.config.select.none"
                            defaultMessage="None"
                        />
                    </em>
                </MenuItem>
                {items && items.map(item => (
                    <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
                ))}
            </MuiSelect>
        </FormControl>
    );
}

export default Select;